import 'css-chunksrc/client/scenes/workloads/graph/calendar/styles.scss';export default {
  "calendar": "_calendar_1imx6_1",
  "main": "_main_1imx6_6",
  "grid": "_grid_1imx6_11",
  "workLoads": "_workLoads_1imx6_18",
  "workLoad": "_workLoad_1imx6_18",
  "day": "_day_1imx6_29",
  "good": "_good_1imx6_40",
  "bad": "_bad_1imx6_44",
  "worse": "_worse_1imx6_48",
  "restDay": "_restDay_1imx6_52"
};